import { exitSearch, lazyEndSearchSession, SearchScenarioId } from 'owa-search';
import { orchestrator } from 'satcheljs';
import isFileSuggestionsSearchAction from '../utils/isFileSuggestionsSearchAction';

export default orchestrator(exitSearch, async actionMessage => {
    if (!isFileSuggestionsSearchAction(actionMessage.scenarioId)) {
        return;
    }

    const endSearchSession = await lazyEndSearchSession.import();
    endSearchSession(SearchScenarioId.FileSuggestions);
});
